import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

// Configure global headers for API requests
Amplify.configure({
  ...awsconfig/*,
  API: {
    REST: {
      headers: async () => {
        try {
          const session = await fetchAuthSession();
          return {
            Authorization: `Bearer ${session.tokens.idToken.toString()}`
          };
        } catch (e) {
          console.error('Error getting auth token', e);
          return {};
        }
      }
    }
  }*/
});

// Helper functions for getting user info
export async function currentAuthenticatedUser() {
  try {
    const { username, userId, signInDetails } = await getCurrentUser();
    //console.log(`The username: ${username}`);
    //console.log(`The userId: ${userId}`);
    //console.log(`The signInDetails: ${signInDetails}`);
    return { username, userId, signInDetails };
  } catch (err) {
    console.log(err);
    return null;
  }
}

export async function currentSession() {
  try {
    const session = await fetchAuthSession();
    const { accessToken, idToken } = session.tokens ?? {};
    return { accessToken, idToken };
  } catch (err) {
    //console.log(err);
    return null;
  }
}